/**
 * View Results Button Helpers
 *
 * Utilities for managing view results buttons in the search modal
 */

interface ViewResultsButtonConfig {
  count: number
  searchTerm: string
}

/**
 * Formats the button text based on result count
 */
export function formatViewResultsText(count: number): string {
  return `View ${count} Result${count !== 1 ? 's' : ''}`
}

/**
 * Generates the search results URL
 */
export function getSearchResultsUrl(searchTerm: string): string {
  return `/search?q=${encodeURIComponent(searchTerm)}`
}

/**
 * Determines if the view results button should be visible
 */
export function shouldShowViewResultsButton(count: number): boolean {
  return count > 0
}

/**
 * Updates a single view results button element
 */
export function updateViewResultsButton(
  button: HTMLElement,
  config: ViewResultsButtonConfig,
  showFn: (element: HTMLElement) => void,
  hideFn: (element: HTMLElement) => void
): void {
  const { count, searchTerm } = config

  if (shouldShowViewResultsButton(count)) {
    button.textContent = formatViewResultsText(count)
    showFn(button)

    // Update href for anchor elements
    if (button.tagName === 'A') {
      (button as HTMLAnchorElement).href = getSearchResultsUrl(searchTerm)
    }
  } else {
    hideFn(button)
  }
}
